export const ROSTER_SELECTED_TUTOR_SCOPE_KEY = 'lrbrain-roster-selected-tutor-scope';

